module.exports = __webpack_public_path__ + "static/media/tr.a81e0637.svg";